/* eslint-disable @typescript-eslint/no-explicit-any */
import Layout from '../../../../common/components/layout/Layout';
import Header from '../../../../common/components/layout/Header';
import PaymentLabels from '../../../../common/components/modules/sports/PaymentLabelsLeft';
import Button from '../../../../common/components/sections/Button';
import LayoutInside from '../../../../common/components/layout/LayoutInside';
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useAuth } from '../../../../context/auth-context';
import { useDispatch, useSelector } from 'react-redux';
import Image from '../../../../common/Image';
import WebPayLogo from '../../../../common/components/images/webpay-plus.svg';
import { attributesBySport } from '../../../../common/data/attributes';
import { createModel } from '../../../../services/payment.service';
import { IGame } from '../../../../modules/sport/interfaces/game';
import { fetchGameById } from '../../../../modules/sport/actions/reducerGame';
import { format } from 'date-fns';
import Loading from '../../../../common/loading/Loading';
import Link from '../../../../common/Link';
import { formatPrice } from '../../../../utils';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const ClubsPayment = (): JSX.Element => {
    const selectGame = (state: any) => state.game;
    const game = useSelector(selectGame);
    const attribute = attributesBySport('integrate');
    const auth = useAuth();
    const dispatch = useDispatch();

    const query = useQuery();
    const [error, setError] = useState('');
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [isRedirecting, setIsRedirecting] = useState(false);
    const [detGame, setDetGame] = useState<IGame | null>(null);
    const [dateMatch, setDateMatch] = useState({ start: '', end: '', date: '', format: '', club: '' });
    const [title, setTitle] = useState<string>();
    const [totalToPay, setTotalToPay] = useState<number>();
    const [linkGame, setLinkGame] = useState<string>();
    const pathname = location.pathname.split('/');
    const sport = pathname.length > 0 ? pathname[1] : 'futbol';
    const gameId = query.get('gameId');
    const [timeGame, setTimeGame] = useState(false);
    const mydate = new Date();

    useEffect(() => {
        setDetGame(null);
        dispatch(fetchGameById(gameId, auth.isLoggedIn));
    }, [gameId]);

    useEffect(() => {
        if (game) {
            setDetGame(game.data?.data);
        }
    }, [game]);

    useEffect(() => {
        if (detGame && detGame.reservation && detGame.reservation.start) {
            //console.log({ detGame });
            const countPlayer =
                !detGame.alreadyPaid && !detGame.alreadyPending
                    ? 1 + parseInt(detGame.guestsCount.toString())
                    : !detGame.alreadyPaid && detGame.alreadyPending
                    ? detGame.totalPaidUser > 0
                        ? parseInt(detGame.pendingGuest.toString())
                        : 1 + parseInt(detGame.pendingGuest.toString())
                    : parseInt(detGame.pendingGuest.toString());
            const totalGame = countPlayer;
            const pricePerPlayer = parseInt(detGame.pricePerPlayer.toString());
            setTotalToPay(pricePerPlayer * totalGame);
            //console.log(totalGame, pricePerPlayer, pricePerPlayer * totalGame);
            setDateMatch({
                start: format(new Date(detGame.reservation?.start), "H':'mm"),
                date: format(new Date(detGame.reservation.start), "dd'-'MM'-'Y"),
                end: format(new Date(detGame.reservation.end), "H':'mm"),
                format: detGame.field.format?.name || '',
                club: detGame.field.club?.name || '',
            });
            const time: number = Date.parse(detGame.reservation?.start) - Date.parse(mydate.toString());
            if (time < 0) {
                setTimeGame(true);
            } else {
                setTimeGame(false);
            }
            const sport = detGame.field?.sport?.name;
            setLinkGame(`/${sport}/integrar/unirse/filter?gameId=${gameId}`);
        }
    }, [detGame]);

    useEffect(() => {
        if (dateMatch) {
            setTitle(`Pago de partido en ${dateMatch.club}`);
        }
    }, [dateMatch]);

    const handleSubmit = async (e: React.SyntheticEvent) => {
        e.preventDefault();
        setError('');
        setIsRedirecting(true);
        const createPayment = async () => {
            //console.log({ data: detGame.reservation.id });
            try {
                const response = await createModel('payments/webpay/create')({
                    reservationId: detGame.reservation.id,
                });
                //console.log('aqui response', { response });
                if (response?.data?.url && response?.data?.token) {
                    const url = `${response.data.url}?token_ws=${response.data.token}`;
                    window.location.href = url;
                }
                setIsRedirecting(false);
            } catch (error) {
                // console.log('aqui error');
                console.log({ error });
                setIsRedirecting(false);
                setError(
                    'Ocurrio un error, le notificaremos al correo para que pueda realizar el pago correspondiente',
                );
            }
        };
        createPayment();
    };

    useEffect(() => {
        if (auth && auth.isLoggedIn && auth.user) {
            setName(auth.user.firstName + ' ' + auth.user.lastName);
            setEmail(auth.user.email);
            setPhone(auth.user.phone ? auth.user.phone : '');
        }
    }, [auth]);

    return (
        <Layout navProps={{ title: 'Pago Arriendo | Supermatch', description: 'Arrienda Supermatch' }}>
            <>
                <Header />
                <LayoutInside attribute={attribute} title={title} breads={[]}>
                    {game && game.isLoading ? (
                        <Loading />
                    ) : (
                        <>
                            {error && (
                                <div className="flex flex-col mx-auto w-full md:w-1/3 mb-2 text-center  font-bold">
                                    <p className="w-full my-6 text-red-500">*{error}</p>
                                </div>
                            )}
                            {timeGame && (
                                <p className="text-center text-2xl italic text-red-500 pt-5">
                                    La fecha de este partido ya paso
                                </p>
                            )}
                            {detGame && detGame.alreadyJoined ? (
                                <>
                                    {!timeGame && (
                                        <div className="flex-col">
                                            <div className="text-center text-2xl italic text-sm-rent pt-5 pb-5">
                                                {auth &&
                                                    auth.user &&
                                                    auth.user.firstName + ' ' + auth.user.lastName + ', '}
                                                estas participando{' '}
                                                {detGame.guestsCount > 0 && (
                                                    <b>
                                                        con {detGame.guestsCount} amigo{detGame.guestsCount > 1 && 's'}
                                                    </b>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                    <div className="w-full md:w-3/5 lg:w-1/2 mx-auto flex-none md:flex  py-4 md:py-6 md:px-16 border-2 bg-white shadow-lg rounded-xl">
                                        {dateMatch && detGame && (
                                            <div className="w-full md:w-1/2 px-4 md:px-0 pb-10 md:pb-0">
                                                <PaymentLabels
                                                    title="Fecha"
                                                    icon="date"
                                                    value={`${dateMatch.date}`}
                                                    sport={sport}
                                                />
                                                <PaymentLabels
                                                    title="Desde"
                                                    icon="time"
                                                    value={`${dateMatch.start} Hrs - ${dateMatch.end} Hrs`}
                                                    sport={sport}
                                                />
                                                <PaymentLabels
                                                    title="Lugar"
                                                    icon="club"
                                                    value={`${detGame.field?.club?.name}`}
                                                    sport={sport}
                                                />
                                                <PaymentLabels
                                                    title="Dirección"
                                                    icon="location"
                                                    value={`${detGame.field?.club?.address}`}
                                                    sport={sport}
                                                />
                                                <PaymentLabels
                                                    title="Cancha"
                                                    icon="field"
                                                    value={`${detGame.field?.name}`}
                                                    sport={sport}
                                                />
                                                {/*detGame.field?.format && (
                                                    <PaymentLabels
                                                        title="Formato"
                                                        icon="date"
                                                        value={`${detGame.field?.format?.name}`}
                                                    />
                                                )*/}
                                                <PaymentLabels
                                                    title="Valor"
                                                    icon="pay"
                                                    value={`${formatPrice(detGame.pricePerPlayer, 0)} por persona`}
                                                    sport={sport}
                                                />
                                                <PaymentLabels
                                                    title="Nombre"
                                                    icon="user"
                                                    value={`${name}`}
                                                    sport={sport}
                                                />
                                                <PaymentLabels
                                                    title="Email"
                                                    icon="email"
                                                    value={`${email}`}
                                                    sport={sport}
                                                />
                                                {phone && (
                                                    <PaymentLabels
                                                        title="Teléfono"
                                                        icon="phone"
                                                        value={phone}
                                                        sport={sport}
                                                    />
                                                )}
                                            </div>
                                        )}
                                        {!timeGame && (
                                            <div className="w-full md:w-1/2 text-center justify-center content-center">
                                                <h3 className="text-xl font-bold italic text-sm-defy pb-4">
                                                    Total a pagar
                                                </h3>
                                                {totalToPay && (
                                                    <div className="flex flex-col text-center justify-center content-center">
                                                        <p className="text-4xl pt-4 font-bold italic text-sm-integrate">
                                                            {formatPrice(totalToPay, 0)}
                                                        </p>
                                                        <Image
                                                            className="mx-auto px-6 pt-4"
                                                            imgClassName=""
                                                            src={WebPayLogo}
                                                            alt="WebPay"
                                                            width={150}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>

                                    {!timeGame && (
                                        <div className="flex flex-col mx-auto w-full md:w-1/3 mt-6 mb-2">
                                            {!detGame.alreadyPaid ? (
                                                <Button
                                                    title={isRedirecting ? 'Espera un momento...' : 'Pagar'}
                                                    handlerClick={handleSubmit}
                                                    disabled={isRedirecting}
                                                />
                                            ) : (
                                                <p className="w-full my-6 text-green-500 bg-gray-200 text-center p-4 shadow-lg rounded-xl font-bold">
                                                    JUEGO PAGADO
                                                </p>
                                            )}
                                        </div>
                                    )}
                                </>
                            ) : (
                                <div className="flex-col">
                                    <div className="text-center text-2xl italic text-sm-rent pt-5 pb-5">
                                        {auth && auth.user && auth.user.firstName + ' ' + auth.user.lastName + ', '}
                                        No estas participando, integrate{' '}
                                        <div className="underline text-blue-700  ">
                                            <Link to={linkGame}>haciendo click aquí</Link>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {error && (
                                <div className="flex flex-col mx-auto w-full md:w-1/3 mt-2 mb-2 text-center  font-bold">
                                    <p className="w-full my-6 text-red-500">*{error}</p>
                                </div>
                            )}
                        </>
                    )}
                </LayoutInside>
            </>
        </Layout>
    );
};

export default ClubsPayment;
